import { Box, Stack } from "@mui/material";
import { DocumentExpirationWarningPopup } from "Components/Dashboard/DocumentExpirationWarningPopup";
import { LimitedAccountPopup } from "Components/Dashboard/LimitedAccountPopup";
import { TransactionFees } from "Components/Dashboard/TransactionFees/TransactionFees";
import { HunterPortalBanner } from "Components/Hunter/HunterPortalBanner/HunterPortalBanner";
import { HunterPrerequisitesWidgetContainer } from "Components/Hunter/Prerequisites/HunterPrerequisitesWidgetContainer";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { MobileAppInstallBanner } from "Components/MobileApp/MobileAppInstallBanner/MobileAppInstallBanner";
import Legione from "Components/Shared/Icons/Legione";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useIsMobile } from "Hooks/useIsMobile";
import { resetTransactionListPagination } from "State/Transactions/TransactionReducer";
import { Resources, useResource } from "Translations/Resources";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { CombinedEarningsSummary } from "Components/Affiliate/Earnings/CombinedEarningsSummary";
import { HandleMissingBanner } from "Components/Social/HandleMissingBanner";

const EARNINGS_RESOURCES = Resources.Components.Affiliate.Earnings;

export const HunterDashboardPage = () => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const { t } = useResource();

  useEffect(() => {
    return () => {
      dispatch(resetTransactionListPagination());
    };
  }, [dispatch]);

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.Dashboard)}
      isTitleHiddenBelowLgScreen
      isPaddingDisabled={isMobile}
    >
      <StyledPageWrapper>
        <Box className="left-content">
          <Stack mx={1} mb={6} mt={isMobile ? 1 : 0} gap={isMobile ? 2 : 1}>
            {isMobile && (
              <Box px={15} mb={4} height={205}>
                <Legione color="white" />
              </Box>
            )}
            <MobileAppInstallBanner />
            <CombinedEarningsSummary
              payoutHint={t(EARNINGS_RESOURCES.CombinedValorPayoutHint)}
              totalEarnedHint={t(
                EARNINGS_RESOURCES.CombinedValorTotalEarnedHint,
              )}
            />
            <HandleMissingBanner />
            <HunterPortalBanner />
            <HunterPrerequisitesWidgetContainer />
            <TransactionFees />
            <LimitedAccountPopup />
            <DocumentExpirationWarningPopup />
          </Stack>
        </Box>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default HunterDashboardPage;
